// extracted by mini-css-extract-plugin
export default {"wrapper":"Map_wrapper__5GcTI"};